import './TypingDots.css';

/**
 * The three animated dots that follow «печатает». Decorative: the word beside
 * it already says what is happening, so this is hidden from assistive tech
 * rather than read out as punctuation.
 */
export function TypingDots() {
  return (
    <span className="typing-dots" aria-hidden="true">
      <span />
      <span />
      <span />
    </span>
  );
}
